export default __webpack_public_path__ + "static/media/icon_todos.da210479.svg";